import { store } from '../../../configureStore';

import { checkPlanReferenceData } from '../../../utils/plansReference';

export const plansReferenceData = checkPlanReferenceData(store.getState()?.plansReferenceData);
export const securePinDataDeviceSucess = store.getState()?.termsAndConditions?.securePinDataDeviceSucess || {};
export const getSmsSuccess = store.getState()?.termsAndConditions?.getSmsSuccess || {};
export const securePinData = store.getState()?.termsAndConditions?.securePinData || {};
export const shippingInfoState = store.getState()?.shippingInfo;
export const shippingInfoDetails = store.getState()?.shippingInfo?.ShippingInfoDetails || {};
export const commonData = store.getState()?.shippingState?.commonData || {};
export const isInvalidOTP = store.getState()?.termsAndConditions?.isInvalidOTP;
export const isInvalidAddressError = store.getState()?.termsAndConditions?.isInvalidAddressError;
export const updateShippingAdressResponse = store.getState()?.termsAndConditions?.updateShippingAdressResponse;
export const updateValidateOTPResponse = store.getState()?.termsAndConditions?.updateValidateOTPResponse;
